/**
 * @generated SignedSource<<5690e2920e6e844f9e0d76f31351b49a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data$data = {
  readonly jira: {
    readonly fieldSetViewQueryByProject: {
      readonly __typename: "JiraFieldSetView";
      readonly fieldSets: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel" | "ui_nativeIssueTable_NativeIssueTable_columns">;
      } | null | undefined;
      readonly hasDefaultFieldSets: boolean | null | undefined;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
    } | {
      readonly __typename: "QueryError";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly issueByKey?: {
      readonly projectField: {
        readonly project: {
          readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_project">;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly issueSearch?: {
      readonly __id: string;
      readonly issueSearchError: {
        readonly __typename: string;
      } | null | undefined;
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_issues">;
    } | null | undefined;
    readonly issueSearchStable?: {
      readonly __id: string;
      readonly issueSearchError: {
        readonly __typename: string;
      } | null | undefined;
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_issues">;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData">;
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data">;
};

import ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery_graphql from './ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v2 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "totalCount"
  },
  {
    "kind": "FragmentSpread",
    "name": "ui_nativeIssueTable_NativeIssueTable_issues"
  },
  {
    "kind": "LinkedField",
    "name": "issueSearchError",
    "plural": false,
    "selections": (v4/*: any*/)
  },
  (v5/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery_graphql
    }
  },
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v0/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "ui_nativeIssueTable_NativeIssueTable_project"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                  },
                  {
                    "kind": "Variable",
                    "name": "before",
                    "variableName": "before"
                  },
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "last",
                    "variableName": "last"
                  }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": (v6/*: any*/)
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearchStable",
                "plural": false,
                "selections": (v6/*: any*/)
              }
            ]
          },
          {
            "args": [
              (v0/*: any*/),
              {
                "kind": "Variable",
                "name": "issueKey",
                "variableName": "issueKey"
              }
            ],
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasDefaultFieldSets"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "fieldSetSelectedState": "SELECTED"
                        }
                      },
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                      }
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "columnPicker_issueViewChildIssuesPanel"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "amountOfColumns",
                        "variableName": "amountOfColumns"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
                  }
                ],
                "type": "JiraFieldSetView"
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "0dce2534ff9c11617c7b9d0666e57e4c";

export default node;
